import { render } from "./app-button-outline-package.vue?vue&type=template&id=4356365f&scoped=true"
import script from "./app-button-outline-package.vue?vue&type=script&lang=js"
export * from "./app-button-outline-package.vue?vue&type=script&lang=js"

import "./app-button-outline-package.vue?vue&type=style&index=0&id=4356365f&scoped=true&lang=css"

import exportComponent from "/var/www/payje-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4356365f"]])

export default __exports__